import { useLocalStorage } from './use-localstorage';

export { writeStorage, deleteFromStorage } from './local-storage-events';

export { useLocalStorage };

export default useLocalStorage;
